const TENANT_ID_LIST_SEPARATOR = /[,\n]+/
export const TENANT_ID_PATTERN = /^\d+$/

export function parseTenantIdList(rawValue) {
  const values = rawValue
    .split(TENANT_ID_LIST_SEPARATOR)
    .map((value) => value.trim())
    .filter((value) => value !== '')
  return [...new Set(values)]
}

export function sortByName(features) {
  return [...features].sort((a, b) => a.name.localeCompare(b.name))
}
